<template>
    <CardPage :section="6" :page="page" :nextDisabled="nextDisabled">
        <p class="font-weight-bold">{{ scenarioText() }}</p>
        <p>
            What are some strategies that might work in this situation? Pick at least 3 that you could use.
        </p>
        <v-container fluid grid-list-xs>
            <v-layout row wrap justify-center>
                <v-flex v-for="(key, index) in strategiesOrder" :key="index" xs3 class="strategy">
                    <a @click.prevent="select(strategies[key])">
                        <ResponsiveImage
                            v-ripple
                            :src="strategies[key].image"
                            :class="{ unselected: !strategies[key][scenario].selected, 'elevation-1': strategies[key][scenario].selected }"
                            class="ma-1"
                            layout=""
                            flex=""
                            :alt="strategies[key].title"
                        ></ResponsiveImage>
                    </a>
                </v-flex>
            </v-layout>
        </v-container>
        <p>{{ text }}</p>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

const MIN_SELECTED = 3;

export default {
    data() {
        return {
            text: ''
        };
    },
    props: {
        page: {
            type: Number,
            required: true
        },
        scenario: {
            type: String,
            required: true
        }
    },
    computed: {
        strategies: get('section6/strategies'),
        strategiesOrder: get('section6/strategiesOrder'),
        scenarioText() {
            return get(`section6/${this.scenario}Text`);
        },
        numSelected() {
            return get(`section6/${this.scenario}Selected`);
        }
    },
    methods: {
        select(strategy) {
            this.$store.set(
                `section6/strategies@${strategy.id}.${this.scenario}.selected`,
                !this.$store.get(`section6/strategies@${strategy.id}.${this.scenario}.selected`)
            );
            if (this.$store.get(`section6/strategies@${strategy.id}.${this.scenario}.selected`)) {
                this.text = this.$store.get(`section6/strategies@${strategy.id}.${this.scenario}.text`);
            } else {
                this.text = '';
            }
        },
        nextDisabled() {
            return this.numSelected() < MIN_SELECTED;
        }
    }
};
</script>

<style scoped>
.strategy {
    position: relative;
}
.unselected {
    opacity: 0.5;
}
</style>
